<template>
  <div>
    <table id="testTree" class="w-full border-blue-lighter">
      <thead :class="{'bg-blue-lightest': listType=='chapter', 'bg-yellow-lightest': listType=='certifiers'}">
        <tr>
          <!-- <th class="p-2 text-sm font-semibold text-center uppercase text-blue-dark" width="36px"></th> -->
          <th class="p-2 text-sm font-semibold text-center uppercase text-blue-dark" width="80px"></th>
          <th class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ displayColumnTitle }}</th>
          <th class="p-2 text-sm font-semibold uppercase text-blue-dark" width="250px">{{ $t("progress") }}</th>
          <th class="p-2 text-sm font-semibold uppercase text-blue-dark"></th>
        </tr>
      </thead>
      <tbody>
        <template v-for="row in listLayers">
          <!-- Recorremos las certificadoras -->
          <tr class="hover:bg-grey-lightest" :class="{'tr-selected': (row.id == selectedChapter) }" :key="'pic_' + row.id">
            <!-- Icono Detalles / Historia -->
            <td class="justify-start w-auto h-full p-2 align-middle">

              <div class="flex text-center align-middle cursor-pointer" @click="displayHistory(row.id)">
                <b-tooltip
                  :label="$t('display_history',[(row.lines ? row.lines.length : 0)])"
                  position="is-right"
                >
                  <span class="mr-1 text-xs font-semibold text-blue">{{ row.lines ? row.lines.length : 0 }}</span>
                  <b-icon icon="history" pack="fas" size="is-small" class="mr-1 text-blue"></b-icon>
                  <b-icon :icon=" (row.id == selectedHistory) ? 'chevron-up' : 'chevron-down'" pack="fas" size="is-small" class="text-blue"></b-icon>
                </b-tooltip>
              </div>
            </td>

            <!-- Chapter -->
            <td v-if="row.completed" class="p-2 align-middle w-auto h-full justify-start">
              <div class="text-xs font-semibold">{{ _GetLayerDisplayName(row) }}</div>
            </td>
            <td  v-else class="p-2">
              <div class="flex flex-row items-center">
                <div class="w-2 h-2 mr-1 rounded-full bg-green"></div>
                <div class="text-xs font-semibold">{{ _GetLayerDisplayName(row) }}</div>
              </div>
              <div class="text-xs text-blue"><span class="font-semibold">{{ $t('resource_weight_msg', [(row.weight ?? 0).toFixed(2)]) }}</span></div>
            </td>
            <!-- Pendiente / Ejecutado -->
            <td class="p-2">
              <div class="flex flex-col">
                <div v-if="! _IsMethodAndAdvanceDefault(row)">
                  <div class="text-xs text-grey-dark">
                    {{ _GetAdvance(row, 'normalize') }}% {{ $t('of') }} 100 ({{ $t('completed1') }})
                    <span @click="_ShowProgressSummaryLayer(row)"
                      class="font-medium text-blue cursor-pointer">
                      <b-icon icon="traffic-light" pack="fas" size="small"></b-icon>
                    </span>
                  </div>
                  <segmented-progress-bar :progress="_GetAdvance(row, 'normalize')" />
                   <!-- <progress-spinner progress="62" /> -->
                </div>
                <div v-else>
                  <div class="text-xs">{{ (row.total_execute ?? '-') }} {{ _GetUnit(row) }} {{ $t("total").toLowerCase() }} {{ _GetEvacuationLineData() }}</div>
                  <div class="text-xs text-grey-dark">
                    {{ row.total_execute != null ? (row.total_execute - (row.progress ?? 0)) : '—' }} {{ _GetUnit(row) }} {{ $t('pendings') }} {{ _GetEvacuationLineEvance(row, 'pendings') }}
                  </div>
                  <div class="text-xs font-medium text-blue">
                    {{ row.progress ?? 0 }} {{ _GetUnit(row) }} {{ 'total '+ $t('executed').toLowerCase() }} {{ _GetEvacuationLineEvance(row, 'executed') }}
                    <b-tooltip position="is-top" multilined>
                      <div @click="_ShowProgressSummaryLayer(row)"><b-icon icon="traffic-light" pack="fas" size="small"></b-icon></div>
                      <template v-slot:content>
                        <div class="text-left">
                          <div>{{ $t('total_executed_by_status') }}</div>
                          <template v-if="_GetActiveStatuses(row).length">
                            <div v-for="status in _GetActiveStatuses(row)" :key="'picstatus_' + status.id" class="mb-1">
                              <span class="w-3 h-3 rounded-full inline-block" :style="{ backgroundColor: status.color }"></span>
                              <span class="border-b border-dotted">{{ status.name }}</span>
                              <span>{{ _GetProgressStatus(row, status) }}</span>
                            </div>
                          </template>
                          <div v-else><span>{{ $t('no_statuses_defined') }}</span></div>
                        </div>
                      </template>
                    </b-tooltip>
                  </div>
                </div>
              </div>
            </td>

            <!-- Opciones -->
            <td class="justify-center w-auto h-full p-4 align-middle">
              <div class="text-center cursor-pointer">
                <b-dropdown aria-role="list" position="is-bottom-left">

                  <template #trigger="{ active }">
                      <b-icon :icon="active ? 'ellipsis-h' : 'ellipsis-v'" pack="fas" size="is-small" class="text-blue"></b-icon>
                  </template>
                  <b-dropdown-item v-if="row.children.length == 0 && !row.completed"
                    aria-role="listitem"
                    @click="onClickOpenModal(row)" >
                    <span class="text-xs">{{ $t('register_progress') }}</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    aria-role="listitem"
                    @click="onClickShowCalendarStaff(row)" >
                    <span class="text-xs">{{ $t('assigned_staff') }}</span>
                  </b-dropdown-item>
                  <b-dropdown-item separator v-if="!row.completed && !row.children.length > 0"></b-dropdown-item>
                </b-dropdown>
              </div>
            </td>
          </tr>

          <details-row v-if="row.children.length"
            :key="'sub_' + row.id"
            :node="row"
            :class="{'hidden': !(row.id == selectedChapter)}"
          />

          <tr  :key="'pictogram_history_'+row.id">
            <td colspan="5" :class="{'hidden': !(row.id == selectedHistory)}" >
                <table class="w-full">

                    <tr class="bg-indigo-lightest">
                      <td colspan="4" class="p-4">
                          <div class="flex justify-start w-auto h-full align-middle">
                          <b-icon icon="history" pack="fas" size="is-small" class="ml-1 text-blue"></b-icon>
                          <span class="ml-2 text-xs font-semibold text-blue">{{ $t('resource_history_header') }}</span>
                          </div>
                      </td>
                    </tr>

                    <tr class="bg-blue-lightest">
                        <th align="center" class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t('date') }}</th>
                        <th class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t('user') }}</th>
                        <th align="center" class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t('action') }}</th>
                        <th class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t('observations') }}</th>
                    </tr>

                    <tbody>
                        <!-- <template v-if="false" v-for="rowHistory in row.lines"> -->
                        <template  v-for="rowHistory in (row.lines || [])">
                          <tr class="hover:bg-grey-lightest" :key="rowHistory.id">

                              <td align="center" class="justify-start w-auto h-full p-4">
                                  <div class="text-xs text-center">
                                  <!--
                                  <l-timeago
                                      :since="rowHistory.created_at"
                                      :locale="locale"
                                      class="my-1 text-xs font-semibold text-blue-light"
                                  />
                                  -->
                                <div class="my-1 text-xs font-semibold text-blue-light">
                                  {{dateToText(rowHistory.created_at)}}
                                </div>

                                  </div>
                              </td>

                              <td class="p-2">

                                <div class="flex flex-row items-center justify-start w-auto h-full">
                                <div class="w-8 h-8 rounded-full">
                                    <img class="w-8 h-8 rounded-full" :src="rowHistory.user.avatar"/>
                                </div>
                                <div class="flex flex-col ml-2">
                                    <div class="text-xs">{{ rowHistory.user.fullname}}</div>
                                    <div class="text-xs text-grey-dark">{{ rowHistory.user.area}}</div>
                                </div>
                                </div>

                              </td>

                              <td align="center" class="h-full p-4">
                                <div class="text-xs">{{ $t('execute') }} {{ rowHistory.executed_quantity}} {{ _GetEvacuationLineEvanceHistory(rowHistory, 'executed') }}</div>
                                <div class="text-xs">
                                  <span class="w-3 h-3 rounded-full inline-block" :style="{ backgroundColor: _GetStatusProperty(rowHistory, 'color') }"></span>
                                  <span>{{ _GetStatusProperty(rowHistory, 'name') }}</span>
                                </div>
                              </td>

                              <td class="w-2/5 p-2">
                                  <div class="flex flex-col">
                                  <div class="text-xs" v-html="rowHistory.observation"></div>
                                  <div class="flex flex-row">

                                    <template v-for="rowDocument in rowHistory.documents">
                                      <b-tooltip :label="rowDocument.name" position="is-top" :key="rowDocument.document_id">
                                        <div @click="showPreview(rowDocument)" class="w-12 h-12 m-1 rounded-lg shadow cursor-pointer bg-grey">
                                          <img class="w-12 h-12 rounded-lg" :src="rowDocument.file.thumbnail" />
                                        </div>
                                      </b-tooltip>
                                    </template>
                                  </div>
                                  </div>
                              </td>

                          </tr>
                        </template>
                    </tbody>
                </table>
            </td>
          </tr>
        </template>
      </tbody>
    </table>

    <div class="mt-5">
      <assigned-staff-calendar ref="assigned_staff_calendar" />
    </div>

    <progress-summary-modal ref="refProgressSummaryModal"
    />
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import DetailsRow from './details-row'
import { format } from 'date-fns'
import AssignedStaffCalendar from '·/components/assigned-staff-calendar.vue'

import ProgressSummaryModal from './progress-summary/progress-summary-modal.vue'

import SegmentedProgressBar from './progress-summary/segmented-progress-bar.vue'

import { isMethodAndAdvanceDefault, getProgressLayerFromMetadata } from '../services/helpers.service'
import { PICTOGRAM_TYPES } from '../constants/pictogram-types'

export default {
  name: 'pictogram-table',

  components: {
    DetailsRow,
    AssignedStaffCalendar,
    ProgressSummaryModal,
    SegmentedProgressBar,
  },
  props: {
    listLayers: { type: Array, require: true },
    statuses: { type: Array, require: true },
    pictogram: { type: Object, require: true },
    columnTitle: { type: String, default: '' },
    listType: { type: String, default: 'pictogram' },
    activityId: { type: Number, default: null },
    subactivityId: { type: Number, default: null }
  },

  data () {
    return {
      selected: undefined,
      selectedHistory: undefined,
      selectedSubHistory: undefined,
      selectedChapter: undefined,
    }
  },

  computed: {
    ...mapGetters({
      locale: "lang/locale",
      project: 'app/project',
    }),
    displayColumnTitle() {
      return this.columnTitle || this.$t('layer');
    },
  },

  mounted() {
    // console.log('listLayers: ', this.listLayers)
  },

  methods: {
    /**
     * En pictogramas mecánicos, pilings/structures/modules se traducen por code.
     * En el resto de tipos (o capas no estándar) se muestra el name del layer.
     */
    _GetLayerDisplayName(layer) {
      if (!layer) return ''

      const mechanicalLayerCodes = ['pilings', 'structures', 'modules']

      if (
        this.pictogram?.type === PICTOGRAM_TYPES.MECHANICAL &&
        mechanicalLayerCodes.includes(layer.code)
      ) {
        return this.$t(layer.code)
      }

      return layer.name
    },

    _GetAdvance(layer, type=null) {
      return getProgressLayerFromMetadata(layer.metadata, type)
    },

    _IsMethodAndAdvanceDefault(layer) {
      // Electrical/trenches no tienen flow de "método de avance" configurable —
      // siempre van con el formato simple (total/pendiente/ejecutado), aun si
      // alguna capa heredó un `config.statuses` no-default en su metadata.
      if (
        this.pictogram?.type === PICTOGRAM_TYPES.ELECTRICAL ||
        this.pictogram?.type === PICTOGRAM_TYPES.DITCHES
      ) {
        return false
      }
      return isMethodAndAdvanceDefault(layer.metadata)
    },

    displayHistory(rowId){
      this.selectedChapter = undefined
      this.selectedHistory = (this.selectedHistory == rowId) ? undefined : rowId;
    },

    dateToText(date) {
      let dateObject = new Date(date);
      return format(dateObject, 'dd/MM/yyyy HH:mm')
    },

    onClickOpenModal(row) {
      // this.$emit('epc-open-modal', row)

      this.$router.push({
        name: 'webviewer.pictograms',
        params: {
          pictogramId: row.pictogram_id,
          wl: row.code
        }
      })
    },

    onClickShowCalendarStaff(row) {
      this.$refs.assigned_staff_calendar.show('pictogram-layer', row.id)
    },

    _GetUnit(row) {
      if (!this.with_unit) return ''

      return row.unit_name || this.project.currency
    },

    _GetProgressStatus(item, status) {
      let value = 0;

      if (this.pictogram.type === PICTOGRAM_TYPES.BURIED_EVACUATION || this.pictogram.type === PICTOGRAM_TYPES.AERIAL_EVACUATION) {
        value = this.pictogram.metadata?.statuses_progress_cumulative?.[item.code]?.[status.id] ?? 0;
        const { amount, unit } = this._CalculateEvacuationUnits(value);

        if (this.pictogram.type === PICTOGRAM_TYPES.BURIED_EVACUATION) {
          return `${value} (${amount.toFixed(2)} ${unit})`;
        }

        return value;
      }

      value = item.statuses_progress?.[status.id] ?? 0;

      return value;
    },

    _GetStatusProperty(row, property) {
      let layer = this.listLayers.find(l => { return l.id == row.layer_id });
      if (layer) {
        const statuses = [
          ...(layer.statuses ?? []),
          ...(layer.incident_statuses ?? [])
        ];
        let status = statuses.find(e => { return e.id == row.status_id })

        if (status)
          return status[property]
      }
      return null
    },

    _GetEvacuationLineData() {
      const data = this.pictogram?.metadata?.evacuation_line_data
      return data ? `(${data.line_length} ${data.unit})` : ''
    },

    _CalculateEvacuationUnits(value) {
      if (!this.pictogram?.metadata?.evacuation_line_data || !this.pictogram.metadata.total_sections) {
        return { amount: 0, unit: '' }
      }

      const { line_length, unit } = this.pictogram.metadata.evacuation_line_data
      const minUnit = line_length / this.pictogram.metadata.total_sections
      return { amount: minUnit * value, unit }
    },

    _GetEvacuationLineEvance(row, type) {
      if (!this.pictogram?.metadata?.evacuation_line_data)
        return ''

      let value = 0;
      if ('pendings' === type) {
        value = row.total_execute - row.progress
      } else { // executed
        value = row.progress
      }

      const { amount, unit } = this._CalculateEvacuationUnits(value)
      return `(${amount.toFixed(2)} ${unit})`
    },

    _GetEvacuationLineEvanceHistory(row, type) {
      if (!this.pictogram?.metadata?.evacuation_line_data)
        return ''

      const { amount, unit } = this._CalculateEvacuationUnits(row.executed_quantity)
      return `(${amount.toFixed(2)} ${unit})`
    },

    _CalculateEvacuationAvance(value) {
      if (!this.pictogram?.metadata?.evacuation_line_data)
        return ''

      const { amount, unit } = this._CalculateEvacuationUnits(value)
      return `(${amount.toFixed(2)} ${unit})`
    },

    _ShowProgressSummaryLayer(layer) {
      this.$refs.refProgressSummaryModal.show(layer)
    },

    _GetActiveStatuses(row) {
      return (row.statuses || []).filter(s => s.type === 'status')
    },
  }
}
</script>

<style lang="scss" scoped>
  table, tr {
    border: 1px solid #ADC2EA;
  }

  span.fa {
    transition: all 400ms;
  }
  span.fa:hover {
    cursor: pointer !important;
    color: #333;
  }
  .tr-selected > td:not(:first-child) {
    background-color: rgba(173, 194, 234, 0.174);
    // color: #fff;
  }
</style>
